import "react";
import { Link } from "react-router-dom";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/content-5.jpg";

//icons
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import RestaurantIcon from "@mui/icons-material/Restaurant"; 

//motion

function Maid() {
  const ourServices = [
  {
    title: "Hire a Housekeeper",
    subtitle: "Professional cleaning and organizational support",
    icon: <CleaningServicesIcon fontSize="large" />,
    route: "/services/housekeeper",
  },
  {
    title: "Hire a Private Chef",
    subtitle: "Skilled chefs specializing in local and international cuisine",
    icon: <RestaurantIcon  fontSize="large" />,
    route: "/services/chef",
  }
];
  return (
    <>
      <>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/booking",
            label: "BOOK NOW",
            color: "info",
          }}
          transparent
          light
        />
        <MKBox
          minHeight="50vh"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        >
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={8}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={{ mx: "auto", textAlign: "center" }}
            >
              <MKTypography
                variant="h2"
                color="white"
                mb={2}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Professional Home Services, Made Simple
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <Card
          sx={{
            p: { xs: 2, md: 4 },
            mx: { xs: 1, md: 4 },
            mt: -8,
            mb: 4,
            borderRadius: "2rem",
            backgroundColor: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(25px) saturate(200%)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          }}
        >
          {/* SERVICES SECTION */}
          <MKBox component="section" py={{ xs: 4, lg: 6 }}>
            <Container>
              <Card
                sx={{
                  p: { xs: 3, md: 5 },
                  mx: { xs: 1, md: 4 },
                  mt: -8,
                  borderRadius: "2rem",
                  backgroundColor: "rgba(255,255,255,0.85)",
                  backdropFilter: "blur(25px) saturate(200%)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                }}
              >
                <MKBox textAlign="center" mb={4}>
                  <MKTypography variant="h3" fontWeight="medium">
                    Select Your Home Service
                  </MKTypography>
                  <MKTypography variant="body2" color="text.secondary">
                    Hire a professional housekeeper or private chef in just a few steps
                  </MKTypography>
                </MKBox>

                <Grid container spacing={4}>
                  {ourServices.map((service) => (
                    <Grid item xs={12} sm={6} md={6} key={service.title}>
                      <Card
                        component={Link}
                        to={service.route}
                        sx={{
                          height: "100%",
                          textDecoration: "none",
                          borderRadius: "1.5rem",
                          p: 4,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          transition: "all 0.3s ease",
                          backgroundColor: "rgba(255,255,255,0.75)",
                          backdropFilter: "blur(20px)",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                          "&:hover": {
                            transform: "translateY(-6px)",
                            boxShadow: "0 25px 45px rgba(0,0,0,0.15)",
                          },
                        }}
                      >
                        <MKBox
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          width={70}
                          height={70}
                          mb={2}
                          borderRadius="50%"
                          sx={{
                            background: "linear-gradient(135deg, #700808, #700808)",
                            color: "#ffffff",
                          }}
                        >
                          {service.icon}
                        </MKBox>

                        <MKTypography variant="h5" fontWeight="medium" mb={1}>
                          {service.title}
                        </MKTypography>

                        <MKTypography variant="body2" color="text.secondary">
                          {service.subtitle}
                        </MKTypography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Card>
            </Container>
          </MKBox>
        </Card>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </>
    </>
  );
}

export default Maid;
